import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::lock
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:365
* @route '/profit-loss/months/lock'
*/
export const lock = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: lock.url(options),
    method: 'post',
})

lock.definition = {
    methods: ["post"],
    url: '/profit-loss/months/lock',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::lock
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:365
* @route '/profit-loss/months/lock'
*/
lock.url = (options?: RouteQueryOptions) => {
    return lock.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::lock
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:365
* @route '/profit-loss/months/lock'
*/
lock.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: lock.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::lock
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:365
* @route '/profit-loss/months/lock'
*/
const lockForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: lock.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::lock
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:365
* @route '/profit-loss/months/lock'
*/
lockForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: lock.url(options),
    method: 'post',
})

lock.form = lockForm

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::unlock
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:378
* @route '/profit-loss/months/unlock'
*/
export const unlock = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: unlock.url(options),
    method: 'post',
})

unlock.definition = {
    methods: ["post"],
    url: '/profit-loss/months/unlock',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::unlock
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:378
* @route '/profit-loss/months/unlock'
*/
unlock.url = (options?: RouteQueryOptions) => {
    return unlock.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::unlock
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:378
* @route '/profit-loss/months/unlock'
*/
unlock.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: unlock.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::unlock
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:378
* @route '/profit-loss/months/unlock'
*/
const unlockForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unlock.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Admin\ProfitLoss\ProfitLossController::unlock
* @see app/Http/Controllers/Admin/ProfitLoss/ProfitLossController.php:378
* @route '/profit-loss/months/unlock'
*/
unlockForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: unlock.url(options),
    method: 'post',
})

unlock.form = unlockForm

const months = {
    lock: Object.assign(lock, lock),
    unlock: Object.assign(unlock, unlock),
}

export default months